// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/efb-power-and-batteries.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/efb-power-and-batteries/efb-power-and-batteries.js';

mount([g0]);
